import { onMounted, onUnmounted } from '@nuxtjs/composition-api'

export function useModalOverflow() {
  onMounted(() => {
    document.documentElement.classList.add('tw-overflow-hidden')
  })

  onUnmounted(() => {
    document.documentElement.classList.remove('tw-overflow-hidden')
  })
}
